<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.slagMeltingPoint") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/slagMeltingPoint">
              <span>{{$t('tlt.slagMeltingPoint')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.slagMeltingPoint.startDate")}}</label>
                  <mmf-datepicker v-model="startDateFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.slagMeltingPoint.endDate")}}</label>
                  <mmf-datepicker v-model="endDateFilter"></mmf-datepicker>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.location.area")}}</label>
                  <select class="form-control" type="text" v-model="plantFilter">
                    <option value="default">{{$t("lbl.basic.select.one")}}</option>
                    <option value="冶炼车间一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                    <option value="冶炼车间二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                    <option value="冶炼车间三期">{{$t('lbl.basic.plant.smelting3')}}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.slagMeltingPoint.shift")}}</label>
                  <select class="form-control" type="text" v-model="shiftFilter">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="甲">{{ $t("lbl.slagMeltingPoint.shiftA") }}</option>
                    <option value="乙">{{ $t("lbl.slagMeltingPoint.shiftB") }}</option>
                    <option value="丙">{{ $t("lbl.slagMeltingPoint.shiftC") }}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.slagMeltingPoint.furnaceName")}}</label>
                  <select class="form-control" type="text" v-model="furnaceName">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                    <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                    <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                    <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                    <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                    <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                  </select>
                  <!-- <input class="form-control" type="text" v-model.trim="furnaceNameFilter" /> -->
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.slagMeltingPoint.furnaceBatch")}}</label>
                  <input class="form-control" type="text" v-model.trim="furnaceBatchFilter" />
                </div>
                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('slagMeltingPoint')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('slagMeltingPoint')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="slagMeltingPointTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="slagMeltingPoint"
                inline-actions-disabled
                :singleChoice="true"
                disableEdit
                disableDelete
              ></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/pelletizing/SlagMeltingPoint";
import { gridFields } from "@/model/prd/qualityMgt/pelletizing/SlagMeltingPoint";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "slagMeltingPoint/getField",
  mutationType: "slagMeltingPoint/updateField"
});

export default {
  name: "SlagMeltingPointList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
    ...mapFields(filterFields),

    ...mapState({
      rows: state => state.slagMeltingPoint.rows,
      tableColumns: gridFields,
      entity: state => state.slagMeltingPoint.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"])
  }
};
</script>
